/*
 * Authors: mariushirjanu
 * Created: 07/06/2022
 */


import { HttpDataService } from '../../../shared/http/http-data.service';
import { Injectable } from '@angular/core';
import { ICountryExtended, IInvoiceHeader, ILocationExtended, IState } from '../../../../type_definitions/datatypes';

export interface IOrderFeesHeader extends IInvoiceHeader {
  bpId:number;
  subject:string;
  period:string;
  invoiceTotal:number;
  invoiceStatus:string;
  proformaStatus?:string;
  currency:string;
  dueDate:string;
  addressReceiver:string;
  zipReceiver:string;
  cityReceiver:string;
  taxIdReceiver:string;
  idCompanyCountryReceiver:number;
  contactNameReceiver:string;
  contactEmailReceiver:string;
  locationReceiver:ILocationExtended;
  registeredNameReceiver:string;
  countryReceiver:ICountryExtended;
  stateReceiver:IState;
  proformaStatusDate?:Date;
  supportTicket:number;
  proformaComment?:string;
  invoiceComment?:string;
  paymentComment?:string;
}

export interface IOrderFeesConfirmProforma {
  dueDate?:Date;
  expectedPaymentDate?:Date;
  reason?:string;
  poNumber?:string;
}

export interface IOrderFeesConfirmPayment {
  confirmed?:boolean;
  paymentDate?:Date;
  comment?:string;
}

export interface IOrderFeesRejectProforma {
  reason?:string;
}

@Injectable()
export class OrderFeesDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /***/
  }

  public loadOrderFeesHeader(invoiceId:number):Promise<IOrderFeesHeader> {
    return this.httpDataService.doGET(
      `rest/orderfees/${invoiceId}/header`,
      undefined,
      undefined,
      'Error loading invoice'
    );
  }

  public saveInvoiceAddress(invoiceId:number, data:IOrderFeesHeader):Promise<IOrderFeesHeader> {
    return this.httpDataService.doPUT(
      `rest/orderfees/${invoiceId}/header`,
      undefined,
      data,
      'Saving invoice…',
      'Error saving invoice'
    );
  }

  public changePaymentType(invoiceId:number, paymentType:string):Promise<IOrderFeesHeader> {
    return this.httpDataService.doPOST(
      `rest/invoices/${invoiceId}/recalculateCharges`,
      undefined,
      { paymentType },
      'Changing payment type…',
      'Error saving payment type'
    );
  }

  public confirmProforma(invoiceid:number, data:IOrderFeesConfirmProforma):Promise<IOrderFeesHeader> {
    return this.httpDataService.doPOST(
      `rest/orderfees/${invoiceid}/confirm`,
      undefined,
      data,
      'Saving…',
      'Error to confirm'
    );
  }

  public confirmPayment(invoiceid:number, data:IOrderFeesConfirmPayment):Promise<IOrderFeesHeader> {
    return this.httpDataService.doPOST(
      `rest/orderfees/${invoiceid}/paymentconfirmation`,
      undefined,
      data,
      'Saving…',
      'Error to confirm'
    );
  }

  public rejectProforma(invoiceid:number, data:IOrderFeesRejectProforma):Promise<IOrderFeesHeader> {
    return this.httpDataService.doPOST(
      `rest/orderfees/${invoiceid}/reject`,
      undefined,
      data,
      'Rejecting proforma…',
      'Error rejecting proforma'
    );
  }
}